export const IS_DEBUG = process.env.NODE_ENV === 'development';
// export const IS_DEBUG = false;

export const LOGO_URL = 'https://timmons-branding.s3.amazonaws.com/Wildfire-Suite/CPP/Logo.png';
export const ICON_URL = 'https://timmons-branding.s3.amazonaws.com/Wildfire-Suite/CPP/bigIcon.png';
export const SPLASH_URL = 'https://timmons-branding.s3.amazonaws.com/Wildfire-Suite/CPP/splashBackground.jpg';

export const AUTH_STATES = Object.freeze({
  INITIALIZING: 'INITIALIZING',
  LOGGED_OUT: 'LOGGED_OUT',
  LOGGING_IN: 'LOGGING_IN',
  LOGGED_IN: 'LOGGED_IN',
  TOKEN_STALE: 'TOKEN_STALE',
  REFRESHING_TOKEN: 'REFRESHING_TOKEN',
  ERROR: 'ERROR'
});

export const COMMUNITY_TYPE_LAYERS = Object.freeze({
  1: 'ne-mw-pam-ref:counties',
  2: 'ne-mw-pam-ref:townshipsCitiesAndTowns',
  3: 'ne-mw-pam-ref:fireDistricts'
});

export const PREF_STATE_KEY = 'preferredState';
export const DATE_MSG = 'Must be a valid date';
export const VE_PREF_STATE_KEY = 've:preferredstate';
export const VE_FIRST_VISIT_KEY = 've:firstvisit';

export const DATA_STATES = Object.freeze({
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
});

export const ZOOMABLES_URL = '/api/pam/GenericObject/GetAllObjectsByKey?objectTypeKey=Zoomable';

export const ACLS = Object.freeze({
  SIGN_IN: 'Can Sign In',
  HELP: 'Can See Help',
  ADD_PLANNING_AREA: 'Can Add Community Plan',
  EDIT_PLANNING_AREA: 'Can Update Community Plan',
  DELETE_PLANNING_AREA: 'Can Delete Community Plan',
  VIEW_PLANS: 'Can View Plans',
  VIEW_COMMUNITIES: 'Can View Communities',
  VIEW_EXPLORER: 'Can View Explorer',
  ADD_COMMUNITY:'Can Add Community',
  DELETE_COMMUNITY:'Can Delete Community',
  ADMIN_DELETE: 'Can Delete The World',
  ADMIN_UNDELETE: 'Can Undelete the world',
  DEVELOPER: 'DEVELOPER'
});

export const FIELD_TYPES = Object.freeze({
  TEXT: 0,
  LONG_TEXT: 1,
  INT: 2,
  FLOAT: 3,
  CURRENCY: 4,
  DATE: 5,
  FLAG: 6,
  CHOICE: 7,
  OBJECT: 10,
  // BYNAMEOBJECTREFERENCE: 11,
  SPATIAL: 20,
  LINK: 100,
  CLUSTER: 120,
  NONE: 999
});
